import Hero from "./Hero.jsx";
import Main from "./Main.jsx";
function LandingPage(){
    return(
        <div>
            <Hero />
            <Main />
        </div>
    )
}
export default LandingPage;